import uploadTokenActions from '../actions/UploadTokenActions';

function removeToken(questionId, state) {
    const newState = { ...state };
    delete newState[questionId];

    return newState;
}

export default function (state = {}, action) {
    switch (action.type) {
    case uploadTokenActions.types.UPLOAD_TOKEN_SET_UPLOAD_TOKEN:
        return Object.assign({}, state, { [action.questionId]: action.uploadToken });

    case uploadTokenActions.types.UPLOAD_TOKEN_REMOVE_UPLOAD_TOKEN:
        return removeToken(action.questionId, state);

    default:
        return state;
    }
}
